export default {"src":"/_next/static/media/remove-reverb.68c7f0eb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};